import React from 'react';

import {
  actions,
  ensurePluginOrder,
  useGetLatest,
  useMountedLayoutEffect,
} from 'react-table';

// Actions
actions.resetSortBy = 'resetSortBy';

// Reducer
function reducer(state, action) {
  if (action.type === actions.resetSortBy) {
    return {
      ...state,
      sortBy: [],
    };
  }
  return { ...state };
}

function useInstance(instance) {
  const {
    columns,
    dispatch,
    plugins,
    autoResetSortBy = false,
  } = instance;

  ensurePluginOrder(
    plugins,
    ['useSortBy'],
    'useResetSortBy'
  );

  const resetSortBy = React.useCallback(
    () => {
      dispatch({ type: actions.resetSortBy });
    },
    [dispatch]
  );

  const getAutoResetSortBy = useGetLatest(autoResetSortBy);

  useMountedLayoutEffect(() => {
    if (getAutoResetSortBy()) {
      dispatch({ type: actions.resetSortBy });
    }
  }, [columns]);

  Object.assign(instance, {
    resetSortBy,
  });
}

const useResetSortBy = (hooks) => {
  hooks.stateReducers.push(reducer);
  hooks.useInstance.push(useInstance);
};

useResetSortBy.pluginName = 'useResetSortBy';

export default useResetSortBy;
